import loadingBg from '@/assets/images/loadingBg.gif';
import optimize from '@/assets/images/optimize.png';
import CustomIcon from '@/components/CustomIcon';
import { ImgUpload } from '@/components/imgUpload';
import { assistantUpdate, workflowLogo } from '@/services/global';
import { CheckCircleFilled, UploadOutlined } from '@ant-design/icons';
import { Access, useAccess, useModel, useRequest } from '@umijs/max';
import { Button, Form, Image, Input, Modal, message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import '../index.less';

const { TextArea } = Input;

export default ({ isHideNode = false }) => {
  const [form] = Form.useForm();
  const access = useAccess();
  const {
    addSquareModal,
    setAddSquareModal,
    setSquareModalInfo,
    squareModalInfo,
  } = useModel('global');
  const [assistantImage, setAssistantImage] = useState<any>('');
  const [createLoading, setCreateLoading] = useState<any>('');
  const [historyPicList, setHistoryPicList] = useState<any>([]);
  const [loadingBtnList, setLoadingBtnList] = useState<any>([
    {
      name: '生成工作流中',
      success: false,
      loading: true,
    },
    {
      name: '生成项目参数',
      success: false,
      loading: false,
    },
    {
      name: '添加知识中',
      success: false,
      loading: false,
    },
  ]);
  const { getAssistantListFn } = useModel('global');

  const { loading: isaAddAssistantIng, run: addAssistantMutate } = useRequest(
    assistantUpdate,
    {
      manual: true,
      onSuccess: async (result, params) => {
        if (result.status === 0) {
          setLoadingBtnList((pre) => {
            return pre.map((item) => {
              item.loading = false;
              item.success = true;
              return item;
            });
          });
          message.success(`助手${squareModalInfo?.id ? '编辑' : '新建'}成功`);
          setAddSquareModal(false);
          getAssistantListFn(result.payload.id);
        }
      },
    },
  );

  const { run: workflowLogoFn, cancel: cancelWorkflowLogoFn} = useRequest(
    workflowLogo,
    {
      manual: true,
      onSuccess: async (res, params) => {
        let img = '';
          try {
            if (Array.isArray(JSON.parse(res?.result?.page_content)?.imageUrl)) {
              let imageUrl = JSON.parse(res?.result?.page_content)?.imageUrl
              img = imageUrl.length > 0? imageUrl[0] : '';
            } else {
              img = JSON.parse(res?.result?.page_content)?.imageUrl;
            }
          } catch (error) {}
          if (img) {
            setAssistantImage(img);
            const historyPicListLo = [...historyPicList];
            if (historyPicListLo?.length >= 5) {
              historyPicListLo.shift();
            }
            historyPicListLo.push(img);
            setHistoryPicList(historyPicListLo);
            form.setFieldsValue({ assistantImage: img });
            setCreateLoading(false);
          } else {
            setCreateLoading(false);
          }
      },
    },
  );

  const generateAiImg = () => {
    form.validateFields().then(async (values) => {
      const { assistantName, assistantDesc } = values;
      setCreateLoading(true);
      workflowLogoFn({
        parameter: {
          agent_name: assistantName,
          agent_description: assistantDesc,
        },
        source: 'AI营销助手',
      })
      // workflowLogo({
      //   parameter: {
      //     agent_name: assistantName,
      //     agent_description: assistantDesc,
      //   },
      //   source: 'AI营销助手',
      // })
      //   .then((res) => {
      //     let img = '';
      //     try {
      //       img = JSON.parse(res?.result?.page_content)?.imageUrl;
      //     } catch (error) {}
      //     if (img) {
      //       setAssistantImage(img);
      //       const historyPicListLo = [...historyPicList];
      //       if (historyPicListLo?.length >= 5) {
      //         historyPicListLo.shift();
      //       }
      //       historyPicListLo.push(img);
      //       setHistoryPicList(historyPicListLo);
      //       form.setFieldsValue({ assistantImage: img });
      //     }
      //   })
      //   .finally(() => {
      //     setCreateLoading(false);
      //   });
    });
  };

  const handleLoadingBtnList = () => {
    let tiamerId: any;
    let sueecss = 0;
    tiamerId = setInterval(() => {
      let change = false;
      sueecss += 1;
      setLoadingBtnList((pre) => {
        return pre.map((item: any, index: number) => {
          if (item.loading && !change) {
            item.loading = false;
            item.success = true;
            change = true;
            pre[index + 1].loading = true;
          }
          if (sueecss > 1) {
            clearInterval(tiamerId);
          }
          return item;
        });
      });
    }, 5000);
  };

  useEffect(() => {
    setLoadingBtnList([
      {
        name: '生成工作流中',
        success: false,
        loading: true,
      },
      {
        name: '生成项目参数',
        success: false,
        loading: false,
      },
      {
        name: '添加知识中',
        success: false,
        loading: false,
      },
    ]);
    setHistoryPicList([]);
  }, [addSquareModal]);

  const okCreate = async (values: any) => {
    const userInfo = localStorage.getItem('user_info');
    if (!values?.assistantImage && !assistantImage)
      return message.warning('请生成助手头像');
    if (!userInfo || !JSON.parse(userInfo).enterpriseExtend) return;
    const { orgName } = JSON.parse(userInfo).enterpriseExtend;
    if(!squareModalInfo?.id) handleLoadingBtnList();
    addAssistantMutate({
      ...values,
      id: squareModalInfo.id,
      assistantImage: assistantImage,
      orgName,
    });
  };

  const renderLoading = useCallback(() => {
    const name = form.getFieldValue('assistantName');
    return (
      <div className="loadingBox">
        <Image src={loadingBg} width={'50%'} preview={false} />
        <div className="loadingText">{name || ''}生成中，请稍等～</div>
        <div className="loadingBtns">
          {loadingBtnList?.map((item: any) => {
            return (
              <Button
                disabled
                key={item.name}
                loading={item.loading}
                className={`loadingBtn ${
                  !item.success && !item.loading ? 'disabled' : ''
                }`}
                icon={item.success && <CheckCircleFilled />}
                type="link"
              >
                {item.name}
              </Button>
            );
          })}
        </div>
      </div>
    );
  }, [loadingBtnList, isaAddAssistantIng]);

  useEffect(() => {
    if (!addSquareModal) {
      form.resetFields();
      setAssistantImage('');
    } else if (addSquareModal && squareModalInfo.id) {
      form.setFieldsValue({
        assistantName: squareModalInfo.assistantName,
        assistantDesc: squareModalInfo.assistantDesc,
      });
      setAssistantImage(squareModalInfo.assistantImage);
      setHistoryPicList([squareModalInfo.assistantImage]);
    }
  }, [addSquareModal, squareModalInfo]);

  return (
    <div
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      className="group-menu-title"
    >
      {!isHideNode && (
        <div className="group-menu-title-text">
          <span>助手广场</span>
          <Access
            key={'SettingOutlined'}
            accessible={access['sys:menu:assistant:create']}
          >
            <CustomIcon
              onClick={() => {
                setAddSquareModal(true);
              }}
              name={'zengjia'}
            />
          </Access>
        </div>
      )}
      <Modal
        centered
        destroyOnClose
        className={squareModalInfo?.id ? '' : !isaAddAssistantIng  ? '' : 'modal_style'}
        width={700}
        title={
          isaAddAssistantIng && !squareModalInfo?.id
            ? ''
            : `${squareModalInfo.id ? '编辑' : '新建'}助手`
        }
        footer={false}
        closable={!isaAddAssistantIng && !squareModalInfo?.id}
        open={addSquareModal}
        onOk={() => {}}
        onCancel={() => {
          setAddSquareModal(false);
        }}
      >
        {isaAddAssistantIng && !squareModalInfo?.id ? (
          renderLoading()
        ) : (
          <Form
            form={form}
            name="basic"
            layout="vertical"
            clearOnDestroy
            variant="filled"
            onFinish={okCreate}
            className="add_form_style"
          >
            <Form.Item
              name="assistantName"
              label={'助手名称'}
              rules={[{ required: true }]}
            >
              <Input showCount maxLength={20} />
            </Form.Item>
            <Form.Item
              name="assistantDesc"
              label={'助手介绍'}
              rules={[{ required: true }]}
            >
              <TextArea
                autoSize={{ minRows: 3, maxRows: 3 }}
                showCount
                maxLength={200}
              />
            </Form.Item>
            <Form.Item
              valuePropName="fileList"
              name="assistantImage"
              label={'助手头像'}
              className="upload_style"
            >
              <ImgUpload
                defaultUrl={assistantImage}
                custIcon={<UploadOutlined className="upload_icon" />}
                callback={(file) => {
                  setAssistantImage(file);
                  form.setFieldsValue({ assistantImage: file });
                }}
              />

              <div className="ai_generate_list">
                <Button
                  loading={createLoading}
                  icon={<img src={optimize} />}
                  className="ai_generate"
                  onClick={generateAiImg}
                >
                  AI生成
                </Button>
                {historyPicList?.length > 0 &&
                  historyPicList.map((item, index) => (
                    <span
                      key={item + index}
                      onClick={() => {
                        setAssistantImage(item);
                        form.setFieldsValue({ assistantImage: item });
                      }}
                      className={`ai_generate_item ${
                        assistantImage === item ? 'active' : ''
                      }`}
                    >
                      <img key={index} src={item} />
                    </span>
                  ))}
              </div>
            </Form.Item>
            <Form.Item>
              <div className="modal_footer" style={{ marginTop: '20px' }}>
                <Button
                  className="cancelBtn margin_r"
                  onClick={() => {
                    cancelWorkflowLogoFn()
                    setCreateLoading(false);
                    setAddSquareModal(false);
                  }}
                >
                  {'取消'}
                </Button>
                <Button
                  className="okBtn"
                  onClick={() => {
                    form.submit();
                  }}
                  loading={createLoading || isaAddAssistantIng}
                  type="primary"
                  htmlType="submit"
                >
                  确定
                </Button>
              </div>
            </Form.Item>
          </Form>
        )}
      </Modal>
    </div>
  );
};
